import React from 'react';
import {searchRlPilotName} from "../../util/standards-util";
import TextField from "@mui/material/TextField";
import {Autocomplete} from "@mui/material";
import {findFlagUrlByIso3Code} from 'country-flags-svg';
import Typography from "@mui/material/Typography";

const RankingListPilotSearchWidget = ({suggestions, regId, onChange=()=>{}}) => {

    const [options, setOptions] = React.useState(suggestions.filter(sug=>sug.regId===regId)[0]?.data ?? []);
    const [value, setValue] = React.useState(options.length>0 ? options[0] : null);
    const [keyTimeout, setKeyTimeout] = React.useState()

    return (
        <Autocomplete
            id="renking-list-pilot-search-widget"
            sx={{ width: 300 }}
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.firstname+" "+option.surname
            }
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            noOptionsText="No pilot found"
            onChange={(event, newValue) => {
                onChange(newValue)
                setValue(newValue);
            }}
            onInputChange={(event, newInputValue) => {
                if (event?.type === 'change') {
                    if (keyTimeout) clearTimeout(keyTimeout)
                    const t = setTimeout(()=> {
                        if (newInputValue && newInputValue.length > 2) {
                            console.log(`***quering ${newInputValue}`)
                            searchRlPilotName(newInputValue,(data) => {
                                    if (data.status===200) {
                                        setOptions(data.data)
                                        setValue(null)
                                    }
                                },
                                (error) => {
                                    console.log(`*** ERROR while searching IGC RL for text = ${newInputValue}`)
                                    console.log(error)
                                }
                            )
                        }
                    },500)
                    setKeyTimeout(t)
                }
            }}
            renderInput={(params) => (
                <TextField {...params} label="Pilot name" fullWidth />
            )}
            renderOption={(props, option) => {
                return (
                    <li {...props}>
                        <img src={findFlagUrlByIso3Code(option.nationality)} style={{width:'2.4em',marginRight:'1em'}}/>
                        {option.firstname} {option.surname}
                        <Typography variant={'body2'} ml={1} color={'#999999'}>
                            (ID={option.pilotid})
                        </Typography>
                    </li>
                );
            }}
        />
    )
}

export default RankingListPilotSearchWidget;